import LinearProgress from '@mui/material/LinearProgress';
import { useAppSelector } from '../../store/hooks';
import { Box } from '@mui/material';
export default function Loader() {
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            minHeight: 4,
            mt: '-4px'
        }
    }, loader.isLoaderOpen ? /*#__PURE__*/ React.createElement(LinearProgress, null) : null);
}
